import React from 'react'
import { Grid, makeStyles, Typography, useTheme } from '@material-ui/core'
import { useSelector } from 'react-redux'
import { mountUrl, getElasticFieldNameByLanguage, replaceImagePath } from '~/utils'
import { useLiterals } from '~/components/Literals'
import { ChevronRight } from '@material-ui/icons'
import { Skeleton } from '@material-ui/lab'

const useStyle = makeStyles((theme) => ({
  productTitle: {
    ...theme.typography.productTitle,
    ...theme.gofind.lineLimit(2)
  }
}))

const ProductItem = ({ product, isSkeleton = false }) => {
  const productImage = replaceImagePath(product)
  const { language } = useSelector((state) => state.config)
  const { getLiteral } = useLiterals()

  const classes = useStyle()

  if (isSkeleton) {
    return (
      <Grid container wrap="nowrap">
        <Grid item style={{ backgroundColor: '#fff', marginRight: 16 }}>
          <Skeleton variant="rect" width={102} height={102} />
        </Grid>
        <Grid item style={{ alignSelf: 'center', width: '100%' }}>
          <Typography className={classes.productTitle}>
            <Skeleton variant="text" />
          </Typography>
          <Typography style={{ marginTop: 14, textTransform: 'lowercase' }}>
            <Skeleton variant="text" />
          </Typography>
        </Grid>
      </Grid>
    )
  }

  return (
    <Grid container wrap="nowrap">
      <Grid item style={{ backgroundColor: '#fff', marginRight: 16 }}>
        <img
          src={mountUrl(productImage, { height: 100 })}
          width={102}
          height={102}
          alt={product[getElasticFieldNameByLanguage(language, 'name')]}
        />
      </Grid>
      <Grid item style={{ alignSelf: 'center' }}>
        <Typography variant="h1" className={classes.productTitle}>
          {product[getElasticFieldNameByLanguage(language, 'name')]}
        </Typography>
        <Typography
          style={{
            marginTop: 14,
            textTransform: 'lowercase',
            display: 'flex',
            gap: 4,
            alignItems: 'center'
          }}
        >
          {getLiteral('2018')}
          <ChevronRight style={{ fontSize: 16, opacity: 0.3 }} />
        </Typography>
      </Grid>
    </Grid>
  )
}

export default ProductItem
